import { $axios, baseURL } from "./config";

export const loginUser = async (form) => {
    return $axios.post('/Login', form);
}

export const ProcessFile = async (formData) => {
    return $axios.post('/ProcessFile', formData);
}

export const resetPasswordRequest = async (fromData) => {
    return $axios.post('/ResetPassword', fromData)
};

export const changePassword = async (data) => {
    return $axios.post('/ChangePassword', data);
};

export const twoFactorAuthenticate = async (data) => {
    return $axios.post('/ValidateOTP', data);
}

export const AddorUpdateRecord = async (Target, operationType, Record_Data) => {
    // console.log(JSON.stringify({
    //     "id": "",
    //     "target": Target,
    //     "operationType": operationType,
    //     "record_Data": Record_Data
    // }))
    return $axios.post('/AddorUpdateRecord', {
        "id": "",
        "target": Target, // user, role, institution, dataset, domain
        "operationType": operationType, // add or update
        "record_Data": Record_Data
    });
}

export const getList = async (option = "") => {
    return $axios.get(`/getList?targetlist=${option}`); //users, institutions, roles, domains, file_datasets or datasets
}

export const getFields = async (datasetID) => {
    return $axios.get(`/getList?targetlist=dataset_fields&id=${datasetID}`);
}

export const getFieldsDataView = async (datasetID) => {
    return $axios.get(`/getList?targetlist=dataset_views&id=${datasetID}`);
}

export const getResourceData = async (resourceID, token) => {
    return $axios.get(`/getData?id=${resourceID}`, { headers: { Authorization: token ? `Bearer ${token || ''}` : '' } });
}

export const getPublicResources = async (list, token) => {
    return $axios.get(`/getList?targetlist=${list}`, { headers: { Authorization: token ? `Bearer ${token || ''}` : '' } });
}

export const getToken = async () => {
    return $axios.get( process.env.REACT_APP_SERVER_URL + `/DataHub/getToken`, { headers: { 'ClientID': "IDSP_Portal", "APIkey": '1hcy5taWNyb3NvZnQuY29tL3dzLzIwM' } });
}


// --------------------------------------------------------------- NOT IN USE
export const register = async (form) => {
    return $axios.post('/register', form);
}

export const addQuestion = async (form) => {
    return $axios.post('/add_question', form);
}

export const getAnalytics = async () => {
    return $axios.get('/get_analytics');
}

export const getRegUsers = async () => {
    return $axios.get('/get_reg_users');
}

export const uploadResourceFile = async (formData) => {
    return $axios.post('/upload-resource-file', formData);
}

export const updateResourceFile = async (formData) => {
    return $axios.put('update-file-resource-file', formData);
};

export const downloadFile = async (fileName) => {
    return $axios.get(`/download-resource-file?fileName=${fileName}`, {
        responseType: 'blob',
        headers: { 'Content-Type': 'application/json' }
    });
}